import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const SignInPage = () => {
  const { identify, error } = useAuth();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      await identify(email);
    } catch (err) {
      setSubmitError(err.message || 'Unable to sign in');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: '480px', margin: '2rem auto' }}>
      <h2 className="card-title">Sign in to Sweat Or Regret</h2>
      <p style={{ color: '#718096', marginBottom: '1.5rem' }}>
        Enter your email to load your fitness data. No password required.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            className="form-input"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@example.com"
            required
            autoComplete="email"
          />
        </div>

        {(submitError || error) && (
          <p style={{ color: '#e53e3e', marginBottom: '1rem' }}>
            {submitError || error}
          </p>
        )}

        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
          style={{ width: '100%' }}
        >
          {isSubmitting ? 'Signing in...' : 'Continue'}
        </button>
      </form>
    </div>
  );
};

export default SignInPage;
